module.exports = __webpack_public_path__ + "static/media/83.b74fd65a.png";